import Reviews from '../../Reviews';
import sanitizeHTML from '../../../utils/sanitiseHTML';

const FullWidthReview = ({ reviewSection }) => {
  return (
    <div className="section__full-width-review">
        <Reviews dangerouslySetInnerHTML={{ __html: sanitizeHTML(reviewSection?.bottomParagraph) }}>
          <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(reviewSection?.title) }}></div>
          <div className="subtitle_1" dangerouslySetInnerHTML={{ __html: sanitizeHTML(reviewSection?.subtitle) }} />
        </Reviews>
    </div>
  );
};

export default FullWidthReview;
